import styled from 'styled-components';
import { AllieIconButton } from '../../../Buttons/IconButton';

export const StyledPaginationFooter: any = styled('div')`
  display: flex;
  justify-content: ${(props: any) => (props.hasItems ? 'space-between' : 'flex-end')};
  padding: 20px;
  background: var(--allie-color-light-main);
`;

export const StyledPagination = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 24px;
`;

export const StyledPaginationInfo = styled('div')`
  display: inline-flex;
  align-items: center;
  color: var(--allie-color-neutral-50);
`;

export const StyledPageIndex = styled(StyledPaginationInfo)``;

export const StyledRowPerPage = styled(StyledPaginationInfo)`
  @media (max-width: 480px) {
    display: none;
  }
`;

export const StyledPaginationNavigation = styled('div')`
  display: inline-flex;
  align-items: center;
`;

export const StyledNavigationButton = styled('button')`
  background-color: transparent;
  font-weight: 300;
  font-size: 15px;
  line-height: 20px;
  color: var(--allie-color-neutral-${(props) => (props.disabled ? '40' : 'main')});
`;

export const StyledFirstPageButton = styled(StyledNavigationButton)`
  @media (max-width: 768px) {
    margin-right: 12px;
  }
  @media (min-width: 768px) {
    margin-right: 30px;
  }
`;

export const StyledPreviousPageButton = styled(StyledNavigationButton)`
  @media (max-width: 768px) {
    margin-right: 24px;
  }
  @media (min-width: 768px) {
    margin-right: 48px;
  }
`;

export const StyledNextPageButton = styled(StyledNavigationButton)``;

export const StyledLastPageButton = StyledNavigationButton;

export const StyledIconButton = styled(AllieIconButton)`
  --border-radius: 25px !important;
  --border-color: var(--allie-color-neutral-30) !important;
  --box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05) !important;

  & span {
    display: flex;
    gap: 8px;
    align-items: center;
    height: 20px;
    color: var(--allie-color-neutral-70);

    ion-icon {
      width: 20px;
      height: 20px;
    }

    & svg {
      width: 20px;
    }
  }
`;

export const StyledPage = styled.button<{ isSelected?: boolean }>`
  width: 36px;
  height: 36px;
  color: ${(props) =>
    props.isSelected ? 'var(--allie-color-black-90) ' : 'var(--allie-color-neutral-60)'};
  background: ${(props) =>
    props.isSelected ? 'var(--allie-color-neutral-5)' : 'var(--allie-color-light-main)'};
  border: ${(props) => (props.isSelected ? '1px solid var(--allie-color-neutral-30)' : '')};
  border-radius: 25px;
`;
